import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import AndroidIcon from "@mui/icons-material/Android";
import { Actividad } from "../Actividad/Actividad";
import { Box, Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import {
  actividadesPublicadas,
  actividadesPublicadasEval,
  actividadesPublicadasGrupo,
} from "./Actividades-Api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import IaxTrimesterSelector from "../UIComponents/IaxTrimesterSelector";
import { evaluacionActual } from "../../util/Functions";
import IaxGroupFilter from "../UIComponents/IaxGroupFilter";

export function Publicadas({ setTitulo }) {
  const [actividades, setActividades] = useState(null);
  const [evaluacionSelected, setEvaluacionSelected] = useState(
    evaluacionActual()
  );
  const [groupSelected, setGroupSelected] = useState("GRUPO");
  const [groupFilterOpen, setGroupFilterOpen] = useState(false);

  setTitulo("Acts. validadas");

  useEffect(() => {
    refrescarActividades();
  }, []);

  useEffect(() => {
    refrescarActividades();
  }, [evaluacionSelected]);

  useEffect(() => {
      refrescarActividades();
  }, [groupSelected]);

  const refrescarActividades = () => {
    if (groupSelected === "GRUPO") {
      actividadesPublicadasEval(evaluacionSelected, setActividades);
    } else {
      actividadesPublicadasGrupo(groupSelected, setActividades);
    }
  };

  const notificarCambio = (msg) => {
    toast.warning(msg);
  };

  // control filtro de grupos
  const openGroupFilter = (act) => {
    setGroupFilterOpen(true);
  };
  const closeGroupFilter = () => {
    setGroupFilterOpen(false);
  };

  return (
    <>
      <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Box
        sx={{
          textAlign: "center",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          {groupSelected === "GRUPO" ? (
            <IaxTrimesterSelector
              value={evaluacionSelected}
              onChange={setEvaluacionSelected}
            ></IaxTrimesterSelector>
          ) : (
            ""
          )}
        </Box>

        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography component="h2" variant="h5">
            {groupSelected}
          </Typography>
          <Button onClick={openGroupFilter}>seleccione grupo</Button>
          <IaxGroupFilter
            open={groupFilterOpen}
            onClose={closeGroupFilter}
            selectedItem={groupSelected}
            setSelectedItem={setGroupSelected}
          ></IaxGroupFilter>
        </Box>
      </Box>
      <Grid container spacing={2}>
        {actividades != null
          ? actividades.map((actividad) => (
              <Grid key={actividad.id} item xs={12} sm={6} md={4}>
                <Actividad
                  act={actividad}
                  setTitulo={setTitulo}
                  refrescar={refrescarActividades}
                  notificar={notificarCambio}
                ></Actividad>
              </Grid>
            ))
          : "no hay actividades"}
      </Grid>
    </>
  );
}
